import React, { useEffect, useState } from "react";
import { Radio, Empty } from "antd";
import CitySelect from "../../components/CitySelect";
import Shop from "../../components/Shop";
import ShopButtons from "../../components/ShopButtons";
import {
  getBrand,
  getRecommendStore,
} from "../../api/apiStore/Recommend/Recommend";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading/Loading.jsx";

function Recommend() {
  let navigate = useNavigate();
  const [storeInfo, setStoreInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let recommendShop = { code: "", name: "" };
  let regionValueObj = { city: "台北市", districts: "中正區" };
  const getBrandHandler = async () => {
    setIsLoading(true);
    const resp = await getRecommendStore(regionValueObj);
    setIsLoading(false);
    if (resp === undefined) {
      setStoreInfo([]);
      return;
    }
    setStoreInfo(resp);
  };
  useEffect(() => {
    getBrandHandler();
  }, []);

  const getChildValue = (value) => {
    regionValueObj.city = value[0];
    regionValueObj.districts = value[1];
    getBrandHandler();
  };

  const onChange = (e) => {
    recommendShop = { code: e.target.code, name: e.target.value };
  };

  const backToRegisterAndInsertValue = (type) => {
    let originalValue = JSON.parse(sessionStorage.getItem("register1"));
    originalValue = {
      ...originalValue,
      recommendCode: recommendShop.code,
      recommendStore: recommendShop.name,
    };
    sessionStorage.setItem("register1", JSON.stringify(originalValue));
    navigate("/registerFirst");
  };

  return (
    <>
      <Loading isLoadingVisible={isLoading}></Loading>
      <CitySelect getChildValue={getChildValue} />
      <Radio.Group style={{ width: "100%" }} onChange={onChange}>
        {storeInfo.length === 0 ? (
          <Empty />
        ) : (
          storeInfo.map((item) => (
            <Shop
              key={item.store_id}
              name={item.title}
              add={item.address}
              code={item.code}
            />
          ))
        )}
      </Radio.Group>
      <ShopButtons backToRegister={backToRegisterAndInsertValue} />
    </>
  );
}

export default Recommend;
